import { render, staticRenderFns } from "./AwardWriteDefaultLayout.vue?vue&type=template&id=2f9b7199&scoped=true&"
import script from "./AwardWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./AwardWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b7199",
  null
  
)

export default component.exports